// API giới hạn size tối đa 1000 nên lấy lần lượt từng trang tới khi đủ total
export async function fetchAllPages(api, url, params) {
  const size = 1000;
  let items = [];
  for (let page = 1; ; page++) {
    const { data, meta } = await api.get(url, { params: { ...params, page, size } });
    items = items.concat(data || []);
    if (!data?.length || items.length >= (meta?.total || 0)) return items;
  }
}

// BE ghi bảng ra xlsx (App/Admin/Export/Excel), FE chỉ tải file về
export async function exportExcel(api, { fileName, sheetName, columns, rows }) {
  const res = await api.post(
    'Admin/Export/Excel',
    {
      fileName,
      sheetName,
      columns,
      rows: rows.map((row) => row.map((v) => (v == null ? '' : String(v)))),
    },
    { responseType: 'blob' },
  );

  const link = document.createElement('a');
  link.href = URL.createObjectURL(new Blob([res.data]));
  link.download = `${fileName}.xlsx`;
  link.click();
  URL.revokeObjectURL(link.href);
}
